// Re-exported from @carbon/shared for legacy
export { PRIVACY_STATEMENT_LINK, SUSTAINABILITY_LINK, COMPENSATE_COM_LINK, STRIPE_PRICING_LINK } from "@carbon/shared";
export const TOU_LINK = "https://www.compensate.com/compensate-plus-terms-of-use";
export const FAQ_LINK = "https://www.compensate.com/faq-compensate-plus";
